import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const RESET_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR = 'RESET_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR';
export type RESET_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR = typeof RESET_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR;
export interface ResetInternalBannerImageUploadError {
    type: RESET_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR;
    bannerId: BannerId;
    resourceId: InternalResourceId;
}
export function resetInternalBannerImageUploadErrorAction(
    bannerId: BannerId,
    resourceId: InternalResourceId
): ResetInternalBannerImageUploadError {
    return {
        type: RESET_INTERNAL_BANNER_IMAGE_UPLOAD_ERROR,
        bannerId,
        resourceId
    };
}
